export const DescargaArchivosMensajes = {
  DESCARGA_INICIADA:
    'Se ha iniciado la descarga de documentos. Le informaremos cuando los documentos estén preparados y listos para ser almacenados en su dispositivo.',
  DESCARGA_SATISFACTORIA:
    'Se ha finalizado la descarga de los documentos del expediente [Número de expediente] de la/el [Entidad].',
  DESCARGA_FALLIDA:
    'Se ha presentado un error y no ha sido posible descargar los documentos. Lo intentaremos nuevamente y le informaremos cuando los documentos estén descargados.',
  DESCARGA_INICIADA_TITULO: 'Descarga iniciada',
  DESCARGA_SATISFACTORIA_TITULO: 'Descarga exitosa',
  DESCARGA_FALLIDA_TITULO: 'Error en la descarga',
  ESTADO_FALLIDO: 'Descarga fallida',
  ESTADO_FINALIZADO: 'Descarga finalizada',
  ESTADO_PREPARACION: 'En preparación',
  DIGITALIZACION_FALLIDA_TITULO: 'No existe el radicado',
  DIGITALIZACION_PENDIENTE_TITULO: 'Pendiente de digitalización',
};
